import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal'
import { deleteObject } from '../../actions/objectToDelete';
import { fetchAllQuotes, deleteQuoteById } from '../../api/quotes';
import './style.css';

export class QuoteApprove extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerUpload = this.handlerUpload.bind(this);
    this.handlerEmail = this.handlerEmail.bind(this);
    this.addQuote = this.addQuote.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
    };

    this.columns = [
      'username',
      'name',
      'description',
    ];

    this.columnNames = [
      'Options',
      'Name',
      'Date Approved',
    ];
  }

  addQuote() {
    this.props.moveToAdd();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentWillMount() {
    this.props.list();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteQuoteById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteQuoteById',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  handlerUpload() {
    this.props.moveToUpload();
  }

  handlerEmail() {
    this.props.moveToEmail();
  }

  render() {
    let userLevel = path(['users', 'userProfile', 'user_level'], this.props);
    let itemsList = path(['quotes', 'list'], this.props);
    let itemActions = {};

    if (!itemsList) {
      return null;
    }

    itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    if (!itemsList || itemsList.length === 0) {
      itemsList = [];
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'format_quote', name: 'Approved Quotes' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Approved Quotes
          </div>
          <div className="card-block">
            <Table
              items={[]}
              columns={this.columns}
              columnNames={this.columnNames}
              itemsPerPage={this.state.itemsPerPage}
              search={this.state.search}
              currentPage={this.state.currentPage}
              onChangeCurrentPage={this.onChangeCurrentPage}
              actions={itemActions}
              onSearch={this.onSearch}
              onChangeItemsPerPage={this.onChangeItemsPerPage}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    list: () => {
      fetchAllQuotes()(dispatch);
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/quotes-edit/' + id));
    },
    moveToUpload: () => {
      dispatch(push('/pages/quotes-upload'));
    },
    moveToEmail: () => {
      dispatch(push('/pages/quotes-email'));
    },
    moveToDelete: () => {
      dispatch(push('/pages/job-cards-delete'));
    },
    moveToAdd: () => {
      dispatch(push('/pages/quote'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteApprove);



// WEBPACK FOOTER //
// ./src/containers/QuoteApprove/index.js